import { render, staticRenderFns } from "./SettingChips.vue?vue&type=template&id=5bd2a625"
import script from "./SettingChips.vue?vue&type=script&lang=js"
export * from "./SettingChips.vue?vue&type=script&lang=js"
import style0 from "./SettingChips.vue?vue&type=style&index=0&id=5bd2a625&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports